import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisabledCondition from "../../../../service/getDisabledCondition"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../constant/helpLinks"

const カバーレイ = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { coverLay: shouldShow } = getDisplayCondition(values)
  const disabled = getDisabledCondition(values)

  return (
    <OneClickField isShow={shouldShow} disabled={disabled.coverLay} legend="カバーレイ" helpURL={HELP_LINKS.カバーレイ}>
      <RadioGroup
        name={FIELD_NAMES.カバーレイ}
        selectedValue={values.coverLay}
        onChange={handlers.radio}
        disabled={disabled.coverLay}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.カバーレイ["12.5μm"].value}>12.5μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.カバーレイ["25μm"].value}>25μm</Radio>
          <Radio value={ESTIMATE_CONSTANT.カバーレイ.グリーンレジスト.value}>グリーンレジスト</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.coverLay} />
    </OneClickField>
  )
}

export default カバーレイ
